import React from 'react';

const SecureDate = () => (
  <input type="text" placeholder="Type date here" />
);

export default SecureDate;
